<template>
  <div v-show="show">
    <b-card title="Categoria de Jurisprudência" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <b-form-group class="col-12 col-sm-6"
          label="* Nome"
          label-for="name"
          description="">

          <b-form-input id="name"
            v-model="form.name"
            placeholder="Titulo"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('name'),
              'is-valid': submitted && !form.errors.has('name')
            }"
            @input="slugify">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-sm-6"
          label="Slug"
          label-for="slug"
          description="(Se vazia será gerada uma slug automática)">

          <b-form-input id="slug"
            v-model="form.slug"
            placeholder="Slug"
            :class="{
              'is-invalid': submitted && form.errors.has('slug'),
              'is-valid': submitted && !form.errors.has('slug')
            }"
            @change="userEditedSlug = true">
          </b-form-input>
        </b-form-group>
      </div>
      <slot name="footer"></slot>
    </b-card>

    <b-card v-if="form.id"
      title="Items da categoria"
      header-tag="header"
      footer-tag="footer">

        <multiple-file-input
        id="file"
        @error="$toasted.error(arguments[1])"
        @success="handleUploadFile"
        :fields="{ category_id: form.id, process_id: form.process_id }"
        :url="processItemHttp.storeByFileRoute()">
      </multiple-file-input>

      <draggable v-model="items" class="sortable-container p-3 row" element="div" @end="handleDrop">
        <component v-for="(item, index) in items"
          :key="`sortable-category-item-${item.id}`"
          :is="processItemEntity.sortableComponent"
          :instance="item"
          :http="processItemHttp"
          :entity="processItemEntity"
          @item-removed="handleRemoveFile(arguments[0])">
        </component>
      </draggable>
    </b-card>
  </div>
</template>

<script>
import slugify from 'slugify'
import { get, set } from 'lodash'
import { processItemsJurisprudence } from '@/_entities'
import { resolveHTTP } from '@/services/api'
import { slugifyOptions } from '@/plugins'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      processing: false,
      show: true,
      userEditedSlug: false,

      locks: {
        processes: true,
        types: true,
        items: true
      },

      selectedProcess: null,
      processes: [],

      selectedType: null,
      types: [],

      processItemEntity: null,
      items: [],

      empty: {
        name: '',
        slug: null,
        process_id: null,
        type_id: null,
        status: true
      }
    }
  },

  watch: {
    '$props': {
      handler: function (newProps) {
        if (!get(newProps, 'form.process_id', false)) {
          this.selectedProcess = null
        }

        if (!get(newProps, 'form.type_id', false)) {
          this.selectedType = null
        }
      },
      deep: true
    }
  },

  computed: {
    ready () {
      return !(this.locks.processes || this.locks.types || this.locks.items)
    }
  },

  methods: {
    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    slugify () {
      const self = this

      if (this.userEditedSlug) {
        return
      }

      self.show = false
      self.form.slug = slugify(self.form.name, slugifyOptions)
      self.$nextTick(() => {
        self.show = true
      })
    },

    refreshFileCollection () {
      const self = this

      self.$Progress.start()

      // Let's grab the most
      self.processItemHttp.index({ params: {
        search: { 'category.id': self.form.id },
        _with: 'file',
        _onepage: true
      }}).then((res) => {
        self.locks.items = false
        self.$Progress.finish()
        self.items = res.data.collection
      }).catch((e) => {
        self.$Progress.fail()
        // self.$toasted.error(e)
        console.error(e)
      })
    },

    handleUploadFile (file, response, progress) {
      // If the upload was successful we need to generate to insert the file on the items collection
      // or update the list completly
      this.items.push(response)
      // if (this.form._attach_files === undefined) {
      //   this.form._attach_files = this.form.initial._attach_files || []
      // }
      // this.form._attach_files.push(response)
      // this.file = response
    },

    handleDrop ({ newIndex, oldIndex }) {
      const self = this

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true
        let previousId = null

        if (newIndex !== 0) {
          previousId = get(self.items[newIndex - 1], 'id', null)
        }

        let elementId = get(self.items[newIndex], 'id')

        self.processItemHttp.resource.put(`${elementId}/after/${previousId || ''}`)
          .finally(() => {
            self.processing = false
          })
      }
    }
  },

  created () {
    const self = this

    resolveHTTP('/bl/processes').index({ params: { _onepage: true } })
      .then(function (res) {
        self.processes = res.data.collection
        self.locks.processes = false

        self.selectedProcess = self.form.process_id
          ? self.processes.find((o) => o.id === self.form.process_id)
          : null
      })

    self.types = [
      { id: 1, name: 'Imagem' },
      { id: 2, name: 'Video' },
      { id: 4, name: 'Arquivos' }
    ]

    self.selectedType = self.form.type_id
      ? self.types.find((o) => o.id === self.form.type_id)
      : null

    self.locks.types = false
    if (self.instance.id) {
      self.form.setInitialValues(self.instance)
      self.form.process_id = self.instance.process_id || null
      self.form.type_id = self.instance.type_id || null
    } else {
      self.form.withData(self.empty).setInitialValues(self.empty)
    }

    self.processItemEntity = processItemsJurisprudence
    self.processItemHttp = processItemsJurisprudence.api || resolveHTTP(processItemsJurisprudence.url)

    // Let'sgrab the most
    self.refreshFileCollection()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/JurisprudenceCategory.vue